// Firebase configuration and initialization
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getAnalytics, logEvent } from "firebase/analytics";
import { getMessaging, getToken, onMessage, isSupported } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyDCq4uL2cRsfRVZI08VhxLOZEGJE_Ug_bU",
  authDomain: "leaksmercy.site",
  databaseURL: "https://leakonly-3ae0a-default-rtdb.firebaseio.com",
  projectId: "leakonly-3ae0a",
  storageBucket: "leakonly-3ae0a.firebasestorage.app",
  messagingSenderId: "523134804138",
  appId: "1:523134804138:web:028afb61c1e553f9ac30d3",
  measurementId: "G-8FLJMPMLJL",
};

// ── VAPID public key للـ FCM Web Push ─────────────────────────────────────────
export const FCM_VAPID_KEY =
  "BHwi3gQdlZq8QA0YFcnElsoS39848evKLVxnMZ7A1kupROcIcleavwJG-skLKA97OethmFbeaO7dYTlszPilpw8";

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Realtime Database
export const db = getDatabase(app);

// Initialize Firestore
export const firestore = getFirestore(app);

// Initialize Authentication
export const auth = getAuth(app);

// Google Auth Provider
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: "select_account" });

// Initialize Firebase Analytics
export const analytics = getAnalytics(app);

// Helper: log custom event
export const logAnalyticsEvent = (eventName, params = {}) => {
  try {
    logEvent(analytics, eventName, params);
  } catch {
    // silently fail if analytics not available
  }
};

// ── Firebase Cloud Messaging ──────────────────────────────────────────────────
let _messaging = null;

// ── تسجيل Service Worker بشكل موثوق قبل أي عملية FCM ──────────────────────
// هذا يحل مشكلة "No SW registration" التي تمنع الحصول على الـ token
export const registerFCMServiceWorker = async () => {
  if (!("serviceWorker" in navigator)) return null;
  try {
    // تحقق أولاً من وجود تسجيل ناشط
    const existing = await navigator.serviceWorker.getRegistration("/");
    if (existing && existing.active) return existing;

    // سجّل firebase-messaging-sw.js من جذر الموقع
    const reg = await navigator.serviceWorker.register("/firebase-messaging-sw.js", {
      scope: "/",
      updateViaCache: "none", // تأكد دائماً من أحدث نسخة
    });

    // انتظر حتى يصبح الـ SW نشطاً (active)
    await new Promise((resolve) => {
      if (reg.active) { resolve(); return; }
      const sw = reg.installing || reg.waiting;
      if (!sw) { resolve(); return; }
      sw.addEventListener("statechange", function handler() {
        if (sw.state === "activated" || sw.state === "active") {
          sw.removeEventListener("statechange", handler);
          resolve();
        }
      });
      // timeout بعد 5 ثوانٍ لضمان عدم التجميد
      setTimeout(resolve, 5000);
    });

    return reg;
  } catch {
    return null;
  }
};

export const getMessagingInstance = async () => {
  if (_messaging) return _messaging;
  try {
    const supported = await isSupported();
    if (!supported) return null;
    _messaging = getMessaging(app);
    return _messaging;
  } catch {
    return null;
  }
};

// الحصول على FCM Token — يُسجّل الـ SW أولاً إذا لم يكن مسجلاً
export const getFCMToken = async () => {
  try {
    if (!("Notification" in window)) return null;
    if (Notification.permission !== "granted") return null;

    // تأكد من تسجيل الـ SW أولاً
    const swReg = await registerFCMServiceWorker();

    const msg = await getMessagingInstance();
    if (!msg) return null;

    const tokenOptions = { vapidKey: FCM_VAPID_KEY };
    if (swReg) tokenOptions.serviceWorkerRegistration = swReg;

    const token = await getToken(msg, tokenOptions);
    return token || null;
  } catch {
    return null;
  }
};

// الاستماع للرسائل في المقدمة (Foreground Messages)
export const onForegroundMessage = async (callback) => {
  try {
    const msg = await getMessagingInstance();
    if (!msg) return () => {};
    return onMessage(msg, callback);
  } catch {
    return () => {};
  }
};

export default app;
